import React, { useState, useRef, useEffect } from 'react'
import { motion } from 'framer-motion'

const BeforeAfterSlider = ({ before, after, title }) => {
  const [sliderPosition, setSliderPosition] = useState(50)
  const [isDragging, setIsDragging] = useState(false)
  const containerRef = useRef(null)

  const handleMove = (event) => {
    if (!isDragging && event.type !== 'mousemove') return
    
    const containerRect = containerRef.current.getBoundingClientRect()
    const x = (event.pageX || event.touches[0].pageX) - containerRect.left
    const position = (x / containerRect.width) * 100
    
    if (position >= 0 && position <= 100) {
      setSliderPosition(position)
    }
  }

  const handleMouseDown = () => setIsDragging(true)
  const handleMouseUp = () => setIsDragging(false)

  useEffect(() => {
    window.addEventListener('mouseup', handleMouseUp)
    window.addEventListener('touchend', handleMouseUp)
    return () => {
      window.removeEventListener('mouseup', handleMouseUp)
      window.removeEventListener('touchend', handleMouseUp)
    }
  }, [])

  return (
    <div 
      ref={containerRef}
      className="relative w-full aspect-[4/3] rounded-xl overflow-hidden cursor-col-resize select-none group shadow-2xl border border-gray-200"
      onMouseMove={handleMove}
      onTouchMove={handleMove}
      onMouseDown={handleMouseDown}
      onTouchStart={handleMouseDown}
    >
      <img src={after} alt="After" className="absolute inset-0 w-full h-full object-cover" />
      <div className="absolute inset-0 w-full h-full overflow-hidden" style={{ clipPath: `inset(0 ${100 - sliderPosition}% 0 0)` }}>
        <img src={before} alt="Before" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute top-4 left-4 px-3 py-1 bg-black/50 backdrop-blur-md rounded-full text-xs font-bold text-white uppercase tracking-widest border border-white/20">
          Before
        </div>
      </div>

      <div className="absolute top-4 right-4 px-3 py-1 bg-accent-maroon/50 backdrop-blur-md rounded-full text-xs font-bold text-white uppercase tracking-widest border border-accent-maroon/20">
        After
      </div>

      <div className="absolute top-0 bottom-0 w-1 bg-white shadow-[0_0_10px_rgba(0,0,0,0.5)] z-10" style={{ left: `${sliderPosition}%` }}>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-10 h-10 bg-white rounded-full shadow-xl flex items-center justify-center z-20 border-4 border-accent-maroon">
          <div className="flex space-x-1">
            <div className="w-1 h-4 bg-accent-maroon rounded-full"></div>
            <div className="w-1 h-4 bg-accent-maroon rounded-full"></div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 inset-x-0 p-4 bg-gradient-to-t from-black/80 to-transparent pt-12">
        <h4 className="text-white font-bold text-lg leading-tight">{title}</h4>
      </div>
    </div>
  )
}

export default BeforeAfterSlider